export default function MySQL_FORMAT() {
  return (
    <div>
      <h2>MySQL_FORMAT</h2>    </div>
  );
}